import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { HeroSection } from "./components/sections/HeroSection";
import { StorySection } from "./components/sections/StorySection";
import { PainSection } from "./components/sections/PainSection";
import { PathwaySection } from "./components/sections/PathwaySection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ToolsSection } from "./components/sections/ToolsSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { FAQSection } from "./components/sections/FAQSection";
import { FinalCTASection } from "./components/sections/FinalCTASection";
import { FooterSection } from "./components/sections/FooterSection";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans" data-id="element-0" data-mp="3recbnd7qcbci">
      <MetaPixel data-id="element-1" data-mp="5gbgztt38r4" />
      <HeroSection data-id="element-2" data-mp="82ohezguggq" />
      <main data-id="element-3" data-mp="2zld0z6e9z99y">
        <StorySection data-id="element-4" data-mp="2zllcouynw8jk" />
        <PainSection data-id="element-5" data-mp="2zmepackaxs9m" />
        <PathwaySection data-id="element-6" data-mp="2zmwggus3xgao" />
        <VolumesSection data-id="element-7" data-mp="33mov9p83gioh" />
        <ToolsSection data-id="element-8" data-mp="33m5e4aq9pybi" />
        <BonusesSection data-id="element-9" data-mp="33nggc642ey0i" />
        <OfferSection data-id="element-10" data-mp="33orhrza1ftog" />
        <GuaranteeSection data-id="element-11" data-mp="38lrpeemjd4ho" />
        <BeforeAfterSection data-id="element-12" data-mp="38li7lebna3n2" />
        <AuthorSection data-id="element-13" data-mp="38k6w0sbyjrle" />
        <TestimonialsSection data-id="element-14" data-mp="38o4h3ji3it7x" />
        <FAQSection data-id="element-15" data-mp="3dle3eqa6uorj" />
        <FinalCTASection data-id="element-16" data-mp="3dlw4c07spr5s" />
      </main>
      <FooterSection data-id="element-17" data-mp="3dirvgpjdy78s" />
      <FloatingCTA data-id="element-18" data-mp="nvsvh92bsvy2" />
      <PurchasePopup data-id="element-19" data-mp="nwc2vvuco1xu" />
    </div>;
}